import {styled} from "@mui/material/styles";

// TODO: In echte CSS-files migrieren. Dies ist hauptsächlich eine Kopie aus src/modules/wma-list/list.js

const PREFIX = "List"

export const classes = {
    listItem: `${PREFIX}-listItem`,
    listLink: `${PREFIX}-listLink`,
    listImg: `${PREFIX}-listImg`,
    titleDiv: `${PREFIX}-titleDiv`,
    titleFlex: `${PREFIX}-titleFlex`,
    title1: `${PREFIX}-title1`,
    title2: `${PREFIX}-title2`,
    title3: `${PREFIX}-title3`,
    numCode: `${PREFIX}-numCode`,
    playButton: `${PREFIX}-playButton`,
    associatedEntity: `${PREFIX}-associatedEntity`,
    associatedLinkIcon: `${PREFIX}-associatedLinkIcon`,
    associatedLinkText: `${PREFIX}-associatedLinkIcon`,
}

export const Root = styled("ul")(({ theme }) => ({
    listStyleType: "none",
    margin: "0",
    marginTop:"10px",
    padding: 0,

    [`& .${classes.listItem}`]: {
        textDecoration: "none",
        padding: "0",
        color: theme.palette.primary.main,
        background: theme.palette.mode === "light" ? "#FFF" : "#333",
        borderColor: theme.palette.mode === "light" ? "#ddd" : "#737373",
        listStyle: "none",
        display: "flex",
        flexDirection:"row",
        justifyContent: "flex-start",
        minHeight: "48px",
        margin: "0",
        overflow: "hidden",
        alignItems: "center",
    },

    [`& .${classes.listLink}`]: {
        textDecoration: "none"
    },

    [`& .${classes.listImg}:not(.hero)`]: {
        width: "100px",
        height: "100px",
    },

    [`& .${classes.titleFlex}`]: {
        display: "flex",
        flexGrow: "1",
        alignItems: "center",
        position: "relative",
        minHeight: "60px",
    },

    [`& .${classes.title1}`]: {
        textTransform: 'uppercase',
        marginBottom: 0,
        lineHeight: 1.15,
    },

    [`& .${classes.title2}`]: {
        fontSize: 17,
        lineHeight: 1.2,
        marginTop: 4,
        paddingRight: 20,
    },

    [`& .${classes.title3}`]: {
        fontSize: "14px",
        marginBottom: "0px",
        marginTop: "2px",
        fontWeight: "normal"
    },

    [`& .${classes.numCode}`]: {
    },

    [`& .${classes.playButton}`]: {
        position: "absolute",
        right: "6px",
        top: "50%",
        transform: "translateY(-50%)"
    },

    [`& .${classes.associatedEntity}`]: {
        display: "block",
        position: "absolute",
        right: "6px",
        bottom: "6px",
        fontSize: "14px",
    },

    [`& .${classes.associatedEntity} a`]: {
        textDecoration: "none",
        color: theme.palette.primary.main,
    },

    [`& .${classes.associatedLinkIcon}`]: {
    },

    [`& .${classes.associatedLinkText}`]: {
    },
}))
